import {
  getAllTaxonomiesUrl,
  getLearningOutcomesTaxonomyUrl,
  getTaxonomyLevelUrl,
} from "../config/Config";
import { deleteRequest, getRequest, postRequest } from "./ServiceHelper";

export class TaxonomyService {
  static getTaxonomyById = (taxonomyId) => {
    return getRequest(getLearningOutcomesTaxonomyUrl(taxonomyId));
  };

  static getAllTaxonomies = () => {
    return getRequest(getAllTaxonomiesUrl());
  };

  static deleteTaxonomyById = (taxonomyId) => {
    return deleteRequest(getLearningOutcomesTaxonomyUrl(taxonomyId));
  };

  static createTaxonomy = (taxonomy) => {
    return postRequest(getAllTaxonomiesUrl(), taxonomy);
  };

  static createTaxonomyLevel = (taxonomyId, taxonomyLevel) => {
    return postRequest(getTaxonomyLevelUrl(taxonomyId), taxonomyLevel);
  };
}
